jQuery(document).ready(function () {
	jQuery(".full-width-video__image-wrapper svg").on("click", function () {
		jQuery(this).closest(".full-width-video__wrapper").addClass("play");
		jQuery(this).closest(".full-width-video__wrapper").find("iframe")[0].src += "?autoplay=1";
	});
});
